import React from 'react';
import { Table } from 'react-bootstrap';
import Row from "./components/Row";
import TotalRow from './components/TotalRow';

const PushapiExtendedTable = ({ report, total, onSortChange }) => {
    const rows = report.map((row, index) => (<Row {...row} key={index} />));

    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <thead>
                <tr>
                    <th onClick={() => onSortChange('subid')}>Subid</th>
                    <th onClick={() => onSortChange('country')}>Country</th>
                    <th onClick={() => onSortChange('spent')}>Spent</th>
                    <th onClick={() => onSortChange('impressions')}>Impressions</th>
                    <th onClick={() => onSortChange('availableClicks')}>Available Clicks</th>
                    <th onClick={() => onSortChange('clicks')}>Clicks</th>
                    <th onClick={() => onSortChange('bid')}>Bid</th>
                    <th onClick={() => onSortChange('onwRevenue')}>Onw Revenues</th>
                    <th onClick={() => onSortChange('revenue')}>Revenues</th>
                    <th onClick={() => onSortChange('totalRevenue')}>Total Revenues</th>
                    <th onClick={() => onSortChange('roi')}>Roi</th>
                    <th onClick={() => onSortChange('roiPercent')}>Roi %</th>
                    <th onClick={() => onSortChange('onwRoi')}>Onw Roi</th>
                    <th onClick={() => onSortChange('WinRate')}>WinRate</th>
                </tr>
            </thead>
            <tbody>
                <TotalRow data={total} />
                {rows}
            </tbody>
        </Table>
    )
};

export default PushapiExtendedTable;


// WEBPACK FOOTER //
// ./src/scenes/ZeroPark/components/Table/index.js